'use client';

import { BuilderComponent, builder, useIsPreviewing } from '@builder.io/react';
import type { BuilderContent } from '@builder.io/sdk';
import { withSuspense } from 'components/with-suspense';
import DefaultErrorPage from 'next/error';
import { renderLink } from './render-link';

export interface BuilderPageProps {
  content?: BuilderContent;
  model?: string;
  data?: any;
}

export function importAdditionalComponents(model?: string) {
  switch (model) {
    case 'product-detail-page':
      require('builder-registries/pdp-builder-registry');
      break;

    case 'cart':
    case 'cart-banner':
    case 'cart-bottom':
      require('builder-registries/cart-builder-registry');
      break;

    case 'search':
    case 'category':
    case 'blog-category':
      require('builder-registries/plp-builder-registry');
      break;

    case 'funnel-landing':
    case 'thank-you':
    case 'funnel-offer':
      require('builder-registries/funnel-builder-registry');
      break;

    default:
      break;
  }
}

export function RenderBuilderPageComponent({ content, model, data }: BuilderPageProps) {
  importAdditionalComponents(model);

  const isPreviewing = useIsPreviewing();
  if (content || isPreviewing) {
    let contentData = {};
    if (content?.data) {
      const { blocks, state, inputs, jsCode, tsCode, cssCode, themeId, ...rest } = content.data;
      contentData = { ...rest };
    }
    return <BuilderComponent
      content={content}
      model={model}
      data={{ 
        config: {
          baseUrl: process.env.NEXT_PUBLIC_DOMAIN_NAME
        },
        ...data,
        ...contentData
      }}
      context={{}}
      renderLink={renderLink}
    />;
  }
  return <DefaultErrorPage statusCode={404} />;
}

export const RenderBuilderPage = withSuspense(RenderBuilderPageComponent, null);
/**
 * @deprecated The method should not be used
 */
export const RenderBuilderContent = withSuspense(RenderBuilderPageComponent, null);